import axios from "axios";

export default {
  async checkIfSamplePsdExist(url) {
    const res = await axios.head(url);

    return !!res.headers["content-length"];
  }
}
